import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import scanPermissionService from "services/scanPermissionService";

export const getAccountScanPermissions = createAsyncThunk(
    "scanPermissions/getScanPermissions",
    async (_, { rejectWithValue }) => {
    try {
      const response = await scanPermissionService.getAccountScanPermissions();
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const scanPermissionsSlice = createSlice({
  name: "scanPermissions",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAccountScanPermissions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAccountScanPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAccountScanPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default scanPermissionsSlice.reducer;